import React from 'react'
import UploadFileComponent from '../../common/UploadFileComponent'

export default () => (<UploadFileComponent
  dataUploadUrl={'/api/plm/replace'}
  description='Upload a csv file that contains a translation table between PLM appearance objects and ICOM material ids'
  supportedFileFormats={['.csv']}
/>)
